// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__37MGV","image":"styles_image__32xbG","bodyContainer":"styles_bodyContainer__mgNrh"};